var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.email)?_c('div',{staticClass:"Avatar__container"},[_c('img',{staticClass:"Avatar",class:_vm.className,attrs:{"src":_vm.imageUrl,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }